module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n      域名详情\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('div', {
    staticClass: "main-area"
  }, [_c('div', {
    staticClass: "operate-panel"
  }, [_c('div', {
    staticClass: "operate-main-panel"
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('span', {
    staticClass: "domain-name"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.dn_top) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "server-name"
  }, [_c('span', {
    staticStyle: {
      "max-width": "9rem"
    }
  }, [_vm._v(_vm._s(_vm.domain.name))])]), _vm._v(" "), _c('div', {
    staticClass: "sub-info"
  }, [_vm._v(_vm._s(_vm.applyDate) + " 至 " + _vm._s(_vm.expireDate))])]), _vm._v(" "), _c('ul', {
    staticClass: "btn-box"
  }, [_c('li', [_c('a', {
    staticClass: "handle-btn domain-analy",
    on: {
      "click": _vm.Analy
    }
  }, [_vm._v("域名解析")]), _vm._v(" "), _c('span', {
    staticClass: "op-btn-cover"
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "domain-infos domain-cerl",
    attrs: {
      "href": 'http://www.abeiyun.com/ertificate.html?id=' + _vm.$route.params.id + '&org=' + _vm.domain.org
    }
  }, [_vm._v("域名证书")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "domain-infos domain-control",
    attrs: {
      "href": '#/user/changedns/' + _vm.$route.params.id,
      "data-index": "1"
    }
  }, [_vm._v("修改DNS")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "more-btn",
    on: {
      "click": function($event) {
        _vm.hide = !_vm.hide
      }
    }
  }, [_c('div', [_vm._v("\n                    更多\n                  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "links-container"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Record
    }
  }, [_c('i', {
    staticClass: "operate-record"
  }), _vm._v(" 操作记录\n                      ")])])])])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "detail-box"
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("域名")]), _vm._v("\n              " + _vm._s(_vm.domain.name) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("所有者")]), _vm._v("\n              " + _vm._s(_vm.organizeman_cn) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("DNS1")]), _vm._v("\n              " + _vm._s(_vm.dns.dns1) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("DNS2")]), _vm._v("\n              " + _vm._s(_vm.dns.dns2) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "detail-row"
  }, [_c('label', [_vm._v("实名认证")]), _vm._v("\n              " + _vm._s(_vm.shiming.auditStatus) + "\n            ")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-circle state-border-success"
  }, [_c('div', {
    staticClass: "product-head-icon server-system-icon"
  }, [_c('span', {
    staticClass: "text-success",
    attrs: {
      "id": "serverStatus",
      "data-status": "1",
      "data-encode_id": "",
      "data-need_refresh_status": "true"
    }
  }, [_vm._v("正常")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "detail-list-tit"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("基本信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-061da975","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/domainmanage.vue
// module id = 6Anv
// module chunks = 1